var storefrontApp = angular.module("storefrontApp");
storefrontApp.controller("aboutusController", [
    "$scope",
    "$rootScope",
    "$window",
    "homeService",
    "randomService",
    "mainService",
    "loaderService",
    function ($scope, $rootScope, $window, homeService, randomService,mainService,loaderService) {
        //#region Get Projects

        $scope.getRecentEmbroideryProjects = function (count) {
            homeService.getEmbroideryProjects(count).then(function (response) {
                if (response && response.data) {
                    $scope.homePageProjects =
                        randomService.getRandomItemsfromListArray(
                            response.data,
                            count
                        );
                } else {
                    //HIDE THE PROJECTS ROW!!
                }
            });
        };

        //#endregion

        //#region initialize
        $scope.initialize = function () {
            $scope.projectTutorialsCount =
                angular.isDefined(window.__env.homepageKeys) &&
                window.__env.homepageKeys.projectTutorialsCount > 0
                    ? window.__env.homepageKeys.projectTutorialsCount
                    : 10;
            $scope.getRecentEmbroideryProjects($scope.projectTutorialsCount);
            $scope.invalidEmail = false;
        };
        //#endregion
        
        //#region submit Email
        $scope.submitSignupEmail = function () {
            loaderService.show();
            if (
                $scope.signUpModal.form.$valid &&
                $scope.signUpModal.form.signupemail.$modelValue.toLowerCase() ==
                    $scope.signUpModal.form.confirmemail.$modelValue.toLowerCase()
            ) {
                var email = $scope.signUpModal.form.confirmemail.$modelValue;
                function handleResponse(response) {
                    loaderService.hide();
                    if (response.data === true) {
                        $scope.signupemail = "";
                        $scope.confirmemail = "";
                        $scope.signUpModal.form.$setPristine();
                        $scope.signUpModal.form.$setUntouched();
                        if (typeof gtag !== 'undefined' && gtag !== null) {
                            gtag('event', 'email_subscribe', {
                                'email': email.toLowerCase()
                            });
                        }
                        $rootScope.$emit("ShowNotificationModal", {
                            modalKey: "SignUpEmail",
                        });
                    }
                    else if (response.data === false) {
                       $scope.invalidEmail = true;
                    }
                    else {

                        if (confirm("The entered email address (" + email + ") seems incorrect. Are you sure you want to sign up using this address?")) {
                            mainService.insertMailingListEmail(email.toLowerCase(), true)
                            .then(handleResponse); 
                        } 
                        else{
                            loaderService.hide();
                        }
                    }
                }
                
                mainService.insertMailingListEmail(email.toLowerCase(), false) 
                .then(handleResponse); 
            } else {
                $scope.signUpModal.form.confirmemail.$invalid = true;
            }
        };

        $scope.resetInvalidEmail = function(){
            $scope.invalidEmail = false;
        }
        //#endregion
        
    },
]);
